<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="this.interface"
      :id="id"
      clean-layout
      :page-table="pageTable"
    >
      <page
        slot="page"
        slot-scope="{ params, forms, showMessage, actionButton }"
        :params="params"
        :forms="forms"
        ref="pageCrudLayout"
        @action-button="
          (button, params, page) => {
            actionForm(button, params, page, actionButton);
          }
        "
        @show-message="showMessage"
      >
        <template slot="form" slot-scope="{ form, actionClick }">
          <crud-form
            ref="crudForm"
            :form="form"
            :model="form.dadosForm"
            @action-click="actionClick"
          >
            <div class="row">
              <crud-input class="col-12 q-px-sm" nmInput="name" />
              <crud-input
                class="col-12 q-px-sm"
                nmInput="zendeskTag"
                @on-select-change="onChangeTag"
              />
              <!-- {{form.dadosForm.zendeskCampaingType}} -->
              <crud-input
                class="col-12 q-px-sm"
                nmInput="zendeskCampaingType"
              />
              <crud-input class="col-12 q-px-sm" nmInput="title" />
              <q-item class="col-12 q-px-sm">
                <q-tabs v-model="tab">
                  <q-tab
                    :disable="!isShowTabEmail"
                    name="email"
                    icon="mdi-email-outline"
                    :label="$gettext('email')"
                  />
                  <q-tab
                    :disable="!isShowTabSMS"
                    name="sms"
                    icon="mdi-message-outline"
                    :label="$gettext('sms')"
                  />
                </q-tabs>
              </q-item>
              <q-item class="col-12 q-px-sm">
                <q-select
                  :disable="!isShowTabEmail && !isShowTabSMS"
                  :options="
                    options.filter((o) => {
                      const exclusions = {
                        50340001: 'TABLE_INSTALMENT_BAR_CODE',
                        50340002: 'TABLE_REF_INVOICE_BAR_CODE',
                      };

                      return (
                        exclusions[form.dadosForm.zendeskCampaingType] !== o.key
                      );
                    })
                  "
                  option-label="description"
                  option-value="key"
                  :label="$gettext('SELECT_VARIABELS_TO_MESSAGE')"
                  emit-value
                  map-options
                  @input="onSelectedOption"
                  class="tw-w-1/3"
                >
                  <template v-slot:append>
                    <q-icon name="help_outline" class="cursor-pointer">
                      <q-tooltip>
                        {{ $gettext("INFO_VARIABLE_CAMPAIGN_DATA") }}
                      </q-tooltip>
                    </q-icon>
                  </template>
                </q-select>
              </q-item>
              <q-tab-panels
                v-model="tab"
                animated
                swipeable
                vertical
                transition-prev="jump-up"
                transition-next="jump-up"
                class="col-12 q-px-sm"
              >
                <q-tab-panel name="email" class="col-12 q-px-sm">
                  <q-item class="tw-w-full">
                    <q-editor
                      v-if="showEditorEmail"
                      :disable="!isShowTabEmail"
                      class="col-12 q-px-sm"
                      :toolbar="[
                        ['bold', 'italic', 'underline'],
                        ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
                      ]"
                      v-model="email"
                      :placeholder="$gettext('VALUE_EMAIL')"
                      :content-type="'text'"
                    />
                  </q-item>
                </q-tab-panel>

                <q-tab-panel name="sms" class="col-12 q-px-sm">
                  <q-item class="tw-w-full">
                    <q-editor
                      :disable="!isShowTabSMS"
                      class="tw-w-full"
                      v-model="sms"
                      :placeholder="$gettext('VALUE_SMS')"
                      :content-type="'text'"
                    />
                  </q-item>
                </q-tab-panel>
              </q-tab-panels>
            </div>
          </crud-form>
        </template>
      </page>
    </crud-layout>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'src/jtech'
import { QEditor } from 'quasar'
import CampaignPageTable from './CampaignPageTable.vue'
import CampaignPageSend from './CampaignPageSend.vue'
const { page, form, input, CrudLayout } = JtCrud
import TurndownService from 'turndown'
@Component({
  name: 'Campaign',
  mixins: [page],
  components: {
    CrudLayout,
    'crud-form': form,
    'crud-input': input,
    form,
    input,
    page,
    QEditor,
    CampaignPageTable,
    CampaignPageSend
  },
  props: {
    id: String,
    interface: String,
    name: String,
    page: Object
  }
})
class Campaign extends Vue {
  tab = 'email';

  actionTagRegister = [];

  options = [];
  selectedOption = null;
  email = '';
  sms = '';
  pageBase = null;

  emailMarkdown = '';
  smsMarkdown = '';

  async mounted () {
    this.$refs.crudLayout.onButton('send-campaign', this.sendCampaign)
    this.$refs.crudLayout.onButton(
      'btGravarSendCampaign',
      this.saveSendCampaign
    )
    this.options = await this.fetchOptions()
  }

  @Watch('email')
  emailData (newValue) {
    const turndownService = new TurndownService()
    this.emailMarkdown = turndownService.turndown(newValue)
  }

  @Watch('sms')
  smsData (newValue) {
    const turndownService = new TurndownService()
    this.smsMarkdown = turndownService.turndown(newValue)
  }

  async saveSendCampaign ({ button, params, page, controller, repository }) {
    const result = await repository.create(
      'zendeskSendCampaing.gravar',
      params
    )
    controller.setPage(this.pageBase.name)
  }

  onSelectedOption (option) {
    const message = ' ${' + this.optionByKey(option) + '} '

    if (this.tab == 'email') {
      this.email += message
    }
    if (this.tab == 'sms') {
      this.sms += message
    }

    this.selectedOption = null
  }

  optionByKey (key) {
    return this.options.filter((option) => option.key == key)[0].description
  }

  async fetchOptions () {
    const result = await repository.resolveLogic(
      'zendeskCampaing.getDataVariableMessageEmailSms'
    )
    return result.registros
  }

  async onChangeTag ({ selectedValue }) {
    const result = await repository.resolveDatatableModel(
      'zendeskServiceManager.pesquisarActionTag',
      { zendeskTag: selectedValue }
    )
    this.actionTagRegister = result.registros
  }

  actionForm (button, params, page, actionClick) {
    params.email = this.emailMarkdown
    params.sms = this.smsMarkdown
    actionClick(button, params, page)
    this.email = ''
    this.sms = ''
  }

  get isShowTabEmail () {
    const isShowEmail =
      this.actionTagRegister.filter((action) => {
        return action.zendeskTagActionType == 'Email'
      }).length > 0
    if (isShowEmail) {
      this.tab = 'email'
    }
    return isShowEmail
  }

  get isShowTabSMS () {
    const isShowSms =
      this.actionTagRegister.filter((action) => {
        return action.zendeskTagActionType == 'SMS'
      }).length > 0
    if (isShowSms) {
      this.tab = 'sms'
    }
    return isShowSms
  }

  get showEditorSms () {
    if (!this.isShowTabEmail && !this.isShowTabSMS) {
      return false
    }
    return this.tab === 'sms'
  }

  get showEditorEmail () {
    if (!this.isShowTabEmail && !this.isShowTabSMS) {
      return true
    }
    return this.tab === 'email'
  }

  get pageTable () {
    return this.campaignPageTable
  }

  get campaignPageTable () {
    return CampaignPageTable
  }

  async sendCampaign ({ button, params, page, controller }) {
    this.pageBase = page
    const forms = await repository.resolve('zendeskSendCampaing.gravar')
    controller.addPage({
      name: this.$gettext('SEND_CAMPAIGN'),
      label: this.$gettext('SEND_CAMPAIGN'),
      component: CampaignPageSend,
      interface: 'zendeskSendCampaing.gravar',
      flClose: true,
      params: params,
      forms: forms,
      page: CampaignPageSend
    })
  }
}
export default Campaign
</script>
<style lang="stylus" scoped></style>
